<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-finDetail-orderExpense',
  components: { PageTable },
}
</script>
